var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9333 2.875C45.3556 1.15 43.6222 0 41.8889 0H10.1111C8.08889 0 6.64444 1.15 6.06667 2.875L0 20.125V43.125C0 44.5625 1.44444 46 2.88889 46H5.77778C7.51111 46 8.66667 44.5625 8.66667 43.125V40.25H43.3333V43.125C43.3333 44.5625 44.7778 46 46.2222 46H49.1111C50.5556 46 52 44.5625 52 43.125V20.125L45.9333 2.875ZM10.9778 5.75H40.7333L43.9111 14.375H8.08889L10.9778 5.75ZM46.2222 34.5H5.77778V20.125H46.2222V34.5ZM13 23C15.3111 23 17.3333 25.0125 17.3333 27.3125C17.3333 29.6125 15.3111 31.625 13 31.625C10.6889 31.625 8.66667 29.6125 8.66667 27.3125C8.66667 25.0125 10.6889 23 13 23ZM39 23C41.3111 23 43.3333 25.0125 43.3333 27.3125C43.3333 29.6125 41.3111 31.625 39 31.625C36.6889 31.625 34.6667 29.6125 34.6667 27.3125C34.6667 25.0125 36.6889 23 39 23Z",
    fill: "#3EAB36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.d298da7b3265c211274672822645fe9f.svg";
export { ForwardRef as ReactComponent };